import thunkMiddleware from 'redux-thunk';
import { compose, createStore, applyMiddleware } from 'redux';
import logger from 'redux-logger';
import { initialState } from 'app/modules';
import reducer from 'app/modules';
import analyticsMiddleware from 'middleware/analyticsMiddleware';
import cookiesMiddleware from 'middleware/cookiesMiddleware';
import { platforms } from '../enums/app';
import webkitMiddleware from 'middleware/webkitMiddleware';
import androidInterfaceMiddleware from 'middleware/androidInterfaceMiddleware';
import storageMiddleware, { getStoredInitialState } from 'middleware/storageMiddleware';
import merge from 'lodash.merge';

export default function configureStore(context) {
  const { deviceConfig } = context;
  const middlewares = [];
  // read stored data in cookies and merge it with the initial state
  // hydrate from cookies
  // TODO: Change this to become hydrateFromDevice where the device
  // could be information from the mobile SDK or cookies + localStorage
  let state = applyDeviceConfig(initialState, deviceConfig);
  state = merge(state, getStoredInitialState(context.gateways.storageGateway));

  if (deviceConfig.platform === platforms.IOS) {
    middlewares.push(webkitMiddleware(context));
  } else if (deviceConfig.platform === platforms.ANDROID) {
    middlewares.push(androidInterfaceMiddleware(context));
  }

  middlewares.push(thunkMiddleware.withExtraArgument({ ...context.gateways }));
  middlewares.push(analyticsMiddleware(context));
  // middlewares.push(errorMiddleware(context)); // Temporary disabled until we fix Sentry client
  middlewares.push(cookiesMiddleware(context.config.appId)); // This should be removed onec we have transition over to storageMiddleware
  middlewares.push(storageMiddleware(context.gateways.storageGateway));

  if (process.env.NODE_ENV === `development`) {
    middlewares.push(logger);
  }

  return compose(applyMiddleware(...middlewares))(createStore)(reducer, state);
}

function applyDeviceConfig(state, deviceConfig) {
  if (!deviceConfig) {
    return state;
  }

  const deviceState = {
    app: {
      platform: deviceConfig.platform,
      deviceId: deviceConfig.deviceId,
    },
  };

  return merge(state, deviceState);
}
